export default __webpack_public_path__ + "static/media/Green0000.6363d09a.png";